import React from 'react';
import { useSSR } from 'react-i18next';

interface InitI18nProps {
  [key: string]: any;
  component: any;
  initialI18nStore: any;
  initialLanguage: string;
}

const InitI18n: React.FC<InitI18nProps> = ({
  component: C,
  initialI18nStore,
  initialLanguage,
  ...props
}) => {
  useSSR(initialI18nStore, initialLanguage);
  return <C {...props} />;
};

export default InitI18n;
